const scrollex = require("../assets/js/jquery.scrollex.min.js");

export default window.scrollex = scrollex;
